// extracted by mini-css-extract-plugin
export var bodyRow = "_hw-d";
export var cardColumns = "_hw-e";
export var ellipsesOverflow = "_hw-2";
export var flatBottomCorners = "_hw-3";
export var flatTopCorners = "_hw-4";
export var headerActionsDropdown = "_hw-f";
export var headerBottomRow = "_hw-c";
export var headerTopRow = "_hw-b";
export var orderDetailsWrapper = "_hw-0";
export var orderInfoContainer = "_hw-1";
export var productDetails = "_hw-9";
export var productImage = "_hw-5";
export var responsiveTable = "_hw-8";
export var shipmentContainer = "_hw-a";
export var tableBottomLeft = "_hw-6";
export var tableBottomRight = "_hw-7";
export var trackingLink = "_hw-g";